module.exports = __webpack_public_path__ + "images/illustrations/illustration-gated-success-01421dd2e8884c114a7da5dd14a27a03.webp";